import React from "react";
import styled from "styled-components";
import { useTheme, Icon, Typography } from "@material-ui/core";
import CopyrightIcon from "@material-ui/icons/Copyright";

export const Copyright = () => {
  const { palette } = useTheme();
  return (
    <>
      <Version colour={palette.primary.light}>Version 3.0.0</Version>
      <CopyrightStyled colour={palette.primary.light}>
        <Text
          style={{ fontSize: "15px", marginRight: "10px", color: "#6E7B8B" }}
        >
          © Copyright 2026 MONITOR WA PTY LTD.
        </Text>
      </CopyrightStyled>
    </>
  );
};

const Version = styled.div`
  text-align: center;
  color: ${(props) => props.colour};
  margin-bottom: 8px;
  font-weight: 700;
  text-transform: uppercase;
`;
const CopyrightStyled = styled.div`
  text-align: center;
  color: ${(props) => props.colour};
`;

const Text = styled(Typography)`
  color: ${(props) => props.colour};
  font-size: 1.2rem;
  line-height: 1;
  margin-right: 1rem;
`;
